import { ICommunicationEntryEntity } from "@odata/GeneratedEntityTypes";
import { KeyboardShortcut } from "@utils/keyboardShortcutsManager/KeyboardShorcutsManager.utils";
import React from "react";

import { withPermissionContext } from "../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend, IFormViewProps } from "../../views/formView/FormView";

interface IProps extends IFormViewProps<ICommunicationEntryEntity> {}

class MessagesFormView extends FormViewForExtend<ICommunicationEntryEntity, IProps> {
    static defaultProps = {
        formProps: {
            shouldHideAuditTrail: true
        }
    };

    async handleKeyboardShortcut(shortcut: KeyboardShortcut, event: KeyboardEvent): Promise<boolean> {
        return false;
    }

    renderButtons = (): React.ReactElement => {
        return null;
    };
}

export default withPermissionContext(MessagesFormView);
